<template>
<div class="chapter">
<div class="inner_page">
<p class="break c"> </p>
<p class="copy x">Copyright © 2022 Matthew E. Sheets</p>
<p class="copy x">All rights reserved.</p>
<p class="copy x">No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means, electronic, mechanical, photocopying, recording, or otherwise, without written permission from the author.</p>
<p class="copy z">ISBN: 978-1-63302-224-9</p>
<p class="copy z">ISBN: 978-1-63302-228-7 (eBook)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?9f93f014